import React, { useState, useEffect } from 'react';
import { inventoryService } from '../../services/api';
import { Customer } from '../../types';

interface CustomerFormProps {
  customer?: Customer;
  onSave: (customerData: any) => void;
  onCancel: () => void;
  isCollapsed: boolean;
  onToggleCollapse: () => void;
  resetForm?: boolean;
}

const CustomerForm: React.FC<CustomerFormProps> = ({ 
  customer, 
  onSave, 
  onCancel, 
  isCollapsed, 
  onToggleCollapse, 
  resetForm
}) => {
  const [formData, setFormData] = useState({
    name: customer?.name || '',
    phone: customer?.phone || '',
    email: customer?.email || '',
    age: customer?.age || '',
    address: customer?.address || '',
    tax_id: customer?.tax_id || '',
    is_active: customer?.is_active ?? true
  });

  useEffect(() => {
    if (resetForm && !customer) {
      setFormData({
        name: '',
        phone: '',
        email: '',
        age: '',
        address: '',
        tax_id: '',
        is_active: true
      });
    } else if (customer) {
      setFormData({
        name: customer.name,
        phone: customer.phone,
        email: customer.email || '',
        age: customer.age || '',
        address: customer.address || '',
        tax_id: customer.tax_id || '',
        is_active: customer.is_active
      });
    }
  }, [customer, resetForm]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const submitData = {
      ...formData,
      age: formData.age ? parseInt(formData.age.toString()) : null
    };
    onSave(submitData);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value, type } = e.target;
    const checked = (e.target as HTMLInputElement).checked;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  return (
    <>
      {!isCollapsed && (
        <form onSubmit={handleSubmit} className="erp-form-body">
          <div className="grid grid-cols-1 sm:grid-cols-6 erp-form-grid">
            <div>
              <label className="erp-form-label">Name *</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="erp-form-input"
              />
            </div>

            <div>
              <label className="erp-form-label">Phone *</label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
                className="erp-form-input"
              />
            </div>

            <div>
              <label className="erp-form-label">Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="erp-form-input"
              />
            </div>

            <div>
              <label className="erp-form-label">Age</label>
              <input
                type="number"
                name="age"
                value={formData.age}
                onChange={handleChange}
                min="0"
                max="150"
                className="erp-form-input"
              />
            </div>

            <div>
              <label className="erp-form-label">
                Address
              </label>
              <textarea
                name="address"
                value={formData.address}
                onChange={handleChange}
                rows={1}
                className="erp-form-input resize-none overflow-y-auto"
                style={{ minHeight: '30px', maxHeight: '30px' }}
              />
            </div>

            <div>
              <label className="erp-form-label">
                Tax ID
              </label>
              <input
                type="text"
                name="tax_id"
                value={formData.tax_id}
                onChange={handleChange}
                className="erp-form-input"
              />
            </div>

            <div className="flex items-center pt-5">
              <input
                type="checkbox"
                name="is_active"
                checked={formData.is_active}
                onChange={handleChange}
                className="h-3 w-3 text-primary focus:ring-primary border-gray-300 rounded"
              />
              <label className="ml-1 block text-xs text-gray-700">
                Active
              </label>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row justify-end" style={{ gap: 'var(--erp-spacing-sm)', marginTop: 'var(--erp-spacing-lg)' }}>
            <button
              type="button"
              onClick={onCancel}
              className="erp-form-btn text-gray-700 bg-gray-100 hover:bg-gray-200"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="erp-form-btn text-white bg-primary hover:bg-secondary"
            >
              {customer ? 'Update' : 'Create'}
            </button>
          </div>
        </form>
      )}
    </>
  );
};

export default CustomerForm;